document.querySelectorAll('.person-card.person-card--has-bio').forEach(card => {
	const bio = card.querySelector('.bio');
  
	card.addEventListener('click', (e) => {
		// e.preventDefault();
		document.querySelectorAll('.person-card.person-card--has-bio').forEach(otherCard => {
			if (otherCard !== card) {
				closeCard(otherCard);
			}
		});

		// toggle the expanded class
		if (card.classList.contains('expanded')) {
			closeCard(card);
			return;
		} else {
			card.classList.add('expanded');
			// get the height of .bio__text and set that to .bio-wrapper
			const bioText = card.querySelector('.bio__text');
			if (bioText) {
				const bioHeight = bioText.offsetHeight;
				const bioWrapper = card.querySelector('.bio-wrapper');
				if (bioWrapper) {
					bioWrapper.style.height = `${bioHeight}px`;
					bioWrapper.style.minHeight = `${bioHeight}px`;
					bioWrapper.style.maxHeight = `${bioHeight}px`;
				}
			}
		}

		// card.classList.add('expanded');

		const bioHeight = bio.offsetHeight;
		const cardRect = card.getBoundingClientRect();
		const offsetFromLeft = cardRect.left;
  
		// Shift the bio left by the card's offset from the left edge
		bio.style.position = 'relative';
		bio.style.left = `-${offsetFromLeft}px`;
		bio.style.width = '100vw';
	
		card.style.marginBottom = `${bioHeight}px`;
		bio.style.opacity = '1';
		bio.style.transform = 'translateY(0)';
	});
  
	function closeCard(card) {
		const bio = card.querySelector('.bio');
		card.classList.remove('expanded');
		card.style.marginBottom = '';
		bio.style.opacity = '0';
		bio.style.transform = 'translateY(-10px)';
	
		// Reset the position
		bio.style.left = '';
		bio.style.width = '';
	}
});